module.exports = __webpack_public_path__ + "static/media/fire_hydrant.122285eb.png";